@if(!isMf()){
  <div class="logo-wrapper">
      <div class="logo">
          <a [routerLink]="['/start']">
              <img loading="lazy" src="assets/images/SvF_RGB_neg.svg" />
          </a>
      </div>
      <div class="title"><a class="light" [routerLink]="['/start']">Kundportalen</a></div>
  </div>
  } @else {
  <div class="logo-wrapper">
      <div class="logo">
          <a [routerLink]="['/start']">
              <img loading="lazy" src="assets/images/Mockfjards_logo_CMYK_ikon_offwhite_CMYK.svg" />
          </a>
      </div>
      <div class="title"><a class="light" [routerLink]="['/start']">Kundportalen</a></div>
  </div>
  }
